import { createContext, useContext } from 'react';
export const ChordClientContext = createContext(null);
ChordClientContext.displayName = 'ChordClientContext';
export function useChord() {
  const chord = useContext(ChordClientContext);
  if (!chord) {
    throw new Error('useChord: This hook only works when the ChordProvider is above it in the React tree.');
  }
  return chord;
}